export class NumberExtensions {
    static GetCurrency(value: any): any {
        return new Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/extensions/number-extensions.ts